import { Tooltip } from 'react-tooltip'

import {
    MILES_WIDGET_TOOLTIP,
    POINTS_DETAIL_TOOLTIP,
    SAND_DOLLARS_WIDGET_TOOLTIP,
    UNWRAPPED_TOKEN_TOOLTIP,
} from '@src/constants/exchange'

export function AllTooltips() {
    return (
        <>
            <Tooltip
                id='unwrapped-token-notification-tooltip'
                style={{ zIndex: 1000, maxWidth: '300px' }}
                render={() => <p className='text-xs'>{UNWRAPPED_TOKEN_TOOLTIP}</p>}
            />
            <Tooltip
                id='points-detail-tooltip'
                style={{ zIndex: 1000, maxWidth: '300px' }}
                render={() => <p className='text-xs'>{POINTS_DETAIL_TOOLTIP}</p>}
            />
            <Tooltip
                id='miles-widget-tooltip'
                style={{ zIndex: 1000, maxWidth: '300px' }}
                render={() => <p className='text-xs'>{MILES_WIDGET_TOOLTIP}</p>}
            />
            <Tooltip
                id='sand-dollars-widget-tooltip'
                style={{ zIndex: 1000, maxWidth: '300px' }}
                render={() => <p className='text-xs'>{SAND_DOLLARS_WIDGET_TOOLTIP}</p>}
            />
        </>
    )
}
